import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import * as EN from "../data/content";
import * as AR from "../data/content.ar";
import { UI } from "../data/ui";

const LanguageContext = createContext(null);
const STORAGE_KEY = "jonaren_lang";

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved === "ar" ? "ar" : "en";
    } catch {
      return "en";
    }
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      /* ignore */
    }
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      isRTL: lang === "ar",
      setLang,
      toggle: () => setLang((l) => (l === "en" ? "ar" : "en")),
      t: UI[lang],
      c: lang === "ar" ? AR : EN,
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
